import "@babel/polyfill";
import Vue from "vue";
import "./plugins/vuetify";
import App from "./App.vue";
import VeeValidate from "vee-validate";

Vue.config.productionTip = false;
Vue.use(VeeValidate, {
  events: "change|blur"
});

new Vue({
  render: h => h(App)
}).$mount("#app");
